export enum ELng {
  EN = 'en',
}

export enum EMenus {
  ENGINE = 'engine',
  BLADES = 'blades',
  PAINT = 'paint',
  COLORS = 'colors',
  ROTATION = 'rotation',
  PROPELLER = 'propeller',
  PLATFORM = 'platform',
  WINGLIGHT = 'winglight',
  WHEELS = 'wheels',
  SKY = 'sky',
}

export enum ESides {
  LEFT = 'left',
  RIGHT = 'right',
}
